<template>
  <md-dialog :md-active.sync="show">
    <md-dialog-title>{{title}}</md-dialog-title>
    <p style="padding: 2em">{{content}}</p>
    <md-dialog-actions>
      <moow-button
        :type="['dark', 'flat','outlined']"
        :btnText="cancelTextLocal"
        @mClick="handleCancel"
      />
      <moow-button
        :type="['light']"
        :btnText="confirmTextLocal"
        @mClick="handleConfirm"
      />
    </md-dialog-actions>
  </md-dialog>
</template>


<script>
// Example usage
//  <moow-button :type="['light', 'outlined', 'flat']" btnText="Testing" icon="edit"></moow-button>

export default {
  props: {
    showDialog: {
        type: Boolean,
        default: false
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      false: false,
    },
    confirmText: {
      type: String,
      false: true,
    },
    cancelText: {
      type: String,
      false: true,
    },
  },
  components: {},
  data() {
    return {
      confirmTextLocal: "Confirm",
      cancelTextLocal: "Cancel",
    };
  },
  filters: {},
  computed: {
      show(){
          return this.showDialog
      }
  },
  mounted() {},
  created() {
      this.confirmText?this.confirmTextLocal=this.confirmText: void 0;
      this.cancelText?this.cancelTextLocal=this.cancelText: void 0;
  },
  methods: {
    handleConfirm(payload) {
      this.$emit("mConfirm", payload);
    },
    handleCancel(payload) {
      this.$emit("mCancel", payload);
    }
  },
};
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/interface/dialogs/moowDialogConfirm.vue